export const windowExists = typeof window !== "undefined";
//# sourceMappingURL=window-exists.js.map